export const timezones = [
  { id: "2", name: "(GMT -11:00) Midway Island", code: -11 },
  { id: "35", name: "(GMT -11:00) Samoa", code: -11 },
  { id: "3", name: "(GMT -10:00) Hawaii", code: -10 },
  { id: "4", name: "(GMT -9:00) Alaska", code: -9 },
  { id: "36", name: "(GMT -8:00) Baja California", code: -8 },
  { id: "5", name: "(GMT -8:00) Pacific Time (US & Canada)", code: -8 },
  { id: "1250000", name: "(GMT +2:00) Maputo, Moçambique", code: 2 },
  { id: "37", name: "(GMT -7:00) Arizona", code: -7 },
  { id: "6", name: "(GMT -7:00) Mountain Time (US & Canada)", code: -7 },
  { id: "39", name: "(GMT -6:00) Central America", code: -6 },
  { id: "7", name: "(GMT -6:00) Central Time (US & Canada)", code: -6 },
  { id: "38", name: "(GMT -6:00) Chihuahua, La Paz, Mazatlan", code: -6 },
  { id: "40", name: "(GMT -6:00) Guadalajara, Mexico City, Monterrey", code: -6 },
  { id: "41", name: "(GMT -6:00) Saskatchewan", code: -6 },
  { id: "42", name: "(GMT -5:00) Bogota, Lima, Quito", code: -5 },
  { id: "8", name: "(GMT -5:00) Eastern Time (US & Canada)", code: -5 },
  { id: "43", name: "(GMT -5:00) Indiana (East)", code: -5 },
  { id: "10", name: "(GMT -4:00) Atlantic Time (Canada)", code: -4 },
  { id: "9", name: "(GMT -4:00) Caracas", code: -4 },
  { id: "45", name: "(GMT -4:00) Cuiaba", code: -4 },
  { id: "46", name: "(GMT -4:00) Georgetown, La Paz, Manaus, San Juan", code: -4 },
  { id: "11", name: "(GMT -3:30) Newfoundland", code: -3.5 },
  { id: "44", name: "(GMT -3:00) Asuncion", code: -3 },
  { id: "12", name: "(GMT -3:00) Brasilia", code: -3 },
  { id: "48", name: "(GMT -3:00) Buenos Aires", code: -3 },
  { id: "49", name: "(GMT -3:00) Cayenne, Fortaleza", code: -3 },
  { id: "50", name: "(GMT -3:00) Greenland", code: -3 },
  { id: "51", name: "(GMT -3:00) Montevideo", code: -3 },
  { id: "47", name: "(GMT -3:00) Santiago", code: -3 },
  { id: "14", name: "(GMT -1:00) Azores", code: -1 },
  { id: "53", name: "(GMT -1:00) Cape Verde Is.", code: -1 },
  { id: "54", name: "(GMT) Casablanca", code: 0 },
  { id: "55", name: "(GMT) Coordinated Universal Time", code: 0 },
  { id: "15", name: "(GMT) Dublin, Edinburgh, Lisbon, London", code: 0 },
  { id: "56", name: "(GMT) Monrovia, Reykjavik", code: 0 },
  { id: "16", name: "(GMT +1:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", code: 1 },
  { id: "57", name: "(GMT +1:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", code: 1 },
  { id: "58", name: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris", code: 1 },
  { id: "166", name: "(GMT +1:00) Lagos", code: 1 },
  { id: "59", name: "(GMT +1:00) Sarajevo, Skopje, Warsaw, Zagreb", code: 1 },
  { id: "60", name: "(GMT +1:00) West Central Africa", code: 1 },
  { id: "62", name: "(GMT +2:00) Amman", code: 1 },
  { id: "64", name: "(GMT +2:00) Beirut", code: 2 },
  { id: "65", name: "(GMT +2:00) Cairo", code: 2 },
  { id: "66", name: "(GMT +2:00) Damascus", code: 2 },
  { id: "68", name: "(GMT +2:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", code: 2 },
  { id: "17", name: "(GMT +2:00) Jerusalem", code: 2 },
  { id: "67", name: "(GMT +02:00) Johannesburg", code: 2 },
  { id: "61", name: "(GMT +2:00) Windhoek", code: 2 },
  { id: "71", name: "(GMT +3:00) Baghdad", code: 3 },
  { id: "63", name: "(GMT +3:00) Istanbul", code: 3 },
  { id: "70", name: "(GMT +3:00) Kuwait, Riyadh", code: 3 },
  { id: "18", name: "(GMT +3:00) Moscow, St. Petersburg, Volgograd", code: 3 },
  { id: "72", name: "(GMT +3:00) Nairobi", code: 3 },
  { id: "19", name: "(GMT +3:30) Tehran", code: 3.5 },
  { id: "20", name: "(GMT +4:00) Abu Dhabi, Dubai, Muscat", code: 4 },
  { id: "73", name: "(GMT +4:00) Baku", code: 4 },
  { id: "21", name: "(GMT +4:30) Kabul", code: 4.5 },
  { id: "22", name: "(GMT +5:00) Ekaterinburg", code: 5 },
  { id: "77", name: "(GMT +5:00) Karachi", code: 5 },
  { id: "23", name: "(GMT +5:30) Chennai, Kolkata, Mumbai, New Delhi", code: 5.5 },
  { id: "79", name: "(GMT +5:30) Colombo", code: 5.5 },
  { id: "24", name: "(GMT +5:45) Kathmandu", code: 5.45 },
  { id: "25", name: "(GMT +6:00) Dhaka", code: 6 },
  { id: "26", name: "(GMT +6:30) Yangon (Rangoon)", code: 6.5 },
  { id: "27", name: "(GMT +7:00) Bangkok, Hanoi, Jakarta", code: 7 },
  { id: "28", name: "(GMT +8:00) Beijing, Chongqing, Hong Kong, Urumqi", code: 8 },
  { id: "178", name: "(GMT +08:00) Manila", code: 8 },
  { id: "113", name: "(GMT +8:00) Singapore", code: 8 },
  { id: "29", name: "(GMT +9:00) Osaka, Sapporo, Tokyo", code: 9 },
  { id: "88", name: "(GMT +9:00) Seoul", code: 9 },
  { id: "91", name: "(GMT +10:00) Brisbane", code: 10 },
  { id: "94", name: "(GMT +10:00) Vladivostok", code: 10 },
  { id: "30", name: "(GMT +10:30) Adelaide", code: 10.5 },
  { id: "31", name: "(GMT +11:00) Canberra, Melbourne, Sydney", code: 11 },
  { id: "32", name: "(GMT +11:00) Solomon Is., New Caledonia", code: 11 },
  { id: "1", name: "(GMT +12:00) Eniwetok, Kwajalein", code: 12 },
  { id: "33", name: "(GMT +13:00) Auckland, Wellington", code: 13 }
];
